<div class="container d-flex justify-content-center align-items-center">
  @if (!updateAvailable) {
    <div class="error text-center">
      <div class=" error__text--number">404</div>
      <div class="error__text--big">{{"ERRORS.PAGE_NOT_FOUND.BIG" | translate}}</div>
      <div class="error__text--small">{{"ERRORS.PAGE_NOT_FOUND.SMALL" | translate}}</div>
    </div>
  } @else {
    <div class="error text-center">
      <app-loader [loading]="true" [cssClasses]="'loader--relative'" />
      <div class=" error__text--big">{{"ERRORS.PAGE_NOT_FOUND.UPDATING" | translate}}</div>
    </div>
  }
</div>
